import uniqid from 'uniqid'
import _cloneDeep from 'lodash.clonedeep'

import types from './types'
import { smartChat } from 'api'
import { reloadSmartchat } from '../header/actions'
import { updateLoading as updateAlternativesLoading, updateError as updateAlternativesError } from '../alternatives/actions'
import { getActionsErrors, typesData } from 'components/SmartChatView/utils'

const getProcessDetail = (payload = {}) => async (dispatch, getStore) => {
  const { onDepth } = payload
  const {
    smartchatHeader: { currentProcess },
    smartchatDetails: { error }
  } = getStore()

  if (error) dispatch(updateError(null))
  if (!onDepth) dispatch(updateLoading(true))

  try {
    const { data: processDetail } = await smartChat.getProcessDetail(currentProcess)
    dispatch({
      type: types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL,
      payload: processDetail
    })
  } catch (error) {
    dispatch(updateError({
      origin: '[Redux] getProcessDetail',
      message: 'chatbot_error_message_back'
    }))
  }

  if (!onDepth) dispatch(updateLoading(false))
}

const deleteProcessDetail = () => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL,
  payload: {}
})

const updateModalActionRef = (payload) => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_MODAL_ACTION_REF,
  payload
})

const setInitialActionDetail = (payload = {}) => (dispatch, getStore) => {
  const { eventType, eventData, actionProperties } = payload
  const { modalActionRef, actionsErrors, modalError } = getStore().smartchatDetails

  if (actionsErrors.action) {
    const _actionsErrors = _cloneDeep(actionsErrors)
    delete _actionsErrors.action
    dispatch(updateActionsErrors(_actionsErrors))
  }
  modalError && dispatch(updateModalError(null))

  let actionDetail = {}

  if (modalActionRef.actionType === 'botAction') {
    actionDetail = {
      eventType,
      actionOrder: 0,
      eventData: eventData || {}
    }
  }
  if (typesData.clientOperatorActionTypes.includes(modalActionRef.actionType)) {
    actionDetail = {
      actionType: modalActionRef.actionType,
      actionOrder: 0,
      actionSubtype: eventType,
      actionProperties: actionProperties || {},
      botActionList: []
    }
  }

  dispatch({
    type: types.SMARTCHAT_DETAILS_SET_ACTION_DETAIL,
    payload: actionDetail
  })
}

const setActionDetail = (payload) => ({
  type: types.SMARTCHAT_DETAILS_SET_ACTION_DETAIL,
  payload: payload
})

const deleteActionDetail = () => ({
  type: types.SMARTCHAT_DETAILS_SET_ACTION_DETAIL,
  payload: {}
})

const setActionValue = (payload) => (dispatch, getStore) => {
  const { modalActionRef, actionDetail } = getStore().smartchatDetails
  const _actionDetail = _cloneDeep(actionDetail)

  if (modalActionRef.actionType === 'botAction') {
    _actionDetail.eventData = { ..._actionDetail.eventData, ...payload }
  }
  if (typesData.clientOperatorActionTypes.includes(modalActionRef.actionType)) {
    _actionDetail.actionProperties = { ..._actionDetail.actionProperties, ...payload }
  }

  dispatch({
    type: types.SMARTCHAT_DETAILS_SET_ACTION_DETAIL,
    payload: _actionDetail
  })
}

const saveActionDetail = (payload = {}) => async (dispatch, getStore) => {
  const { previewActionRef, previewActionDetail,  onFinish } = payload
  const {
    smartchatHeader: { header },
    smartchatDetails: { processDetail, modalActionRef, actionDetail, actionsErrors, modalError },
    smartchatAlternatives: { error }
  } = getStore()

  if (Object.keys(modalActionRef).length) {
    if (modalError) dispatch(updateModalError(null))
    dispatch(updateModalLoading(true))
  } else {
    if (error) dispatch(updateAlternativesError(null))
    dispatch(updateAlternativesLoading(true))
  }

  let currentActionRef = _cloneDeep(modalActionRef)
  if (!Object.keys(modalActionRef).length && previewActionRef) currentActionRef = previewActionRef
  let currentActionDetail = _cloneDeep(actionDetail)
  if (!Object.keys(actionDetail).length && previewActionDetail) currentActionDetail = previewActionDetail

  /* INICIO COMPROBACIÓN DE DATOS */
  if (Object.keys(modalActionRef).length && currentActionRef.mode !== 'delete') {
    const errors = { ...actionsErrors, ...getActionsErrors({ actionType: currentActionRef.actionType, actionData: currentActionDetail }) }

    if (Object.keys(errors).length) {
      if (!actionsErrors || !Object.keys(actionsErrors).length) {  // Solo se notifican nuevos errores si no existen anteriores
        dispatch(updateActionsErrors(errors))
      }
      dispatch(updateModalError({ origin: '[Redux] saveActionDetail', message: 'dashboard_all-required-field' }))
      dispatch(updateModalLoading(false))
      return
    }
  }
  /* FIN COMPROBACIÓN DE DATOS */

  const _processDetail = _cloneDeep(processDetail)
  if (currentActionRef.actionType === 'botAction') {
    if (currentActionRef.fromActionType) {
      const containerIndex = _processDetail.onProcess.findIndex(onProcess => onProcess.containerId === currentActionRef.containerId)
      if (currentActionRef.mode === 'add') _processDetail.onProcess[containerIndex].actionList[currentActionRef.fromActionIndex].botActionList.push(currentActionDetail)
      if (currentActionRef.mode === 'update') _processDetail.onProcess[containerIndex].actionList[currentActionRef.fromActionIndex].botActionList[currentActionRef.actionIndex] = currentActionDetail
      if (currentActionRef.mode === 'delete') {
        const _actionList = _cloneDeep(_processDetail.onProcess[containerIndex].actionList[currentActionRef.fromActionIndex].botActionList)
        _actionList.splice(currentActionRef.actionIndex, 1)
        _processDetail.onProcess[containerIndex].actionList[currentActionRef.fromActionIndex].botActionList = _actionList
      }
    } else {
      if (currentActionRef.mode === 'add') _processDetail[currentActionRef.containerType].actionList.push(currentActionDetail)
      if (currentActionRef.mode === 'update') _processDetail[currentActionRef.containerType].actionList[currentActionRef.actionIndex] = currentActionDetail
      if (currentActionRef.mode === 'delete') {
        const _actionList = _cloneDeep(_processDetail[currentActionRef.containerType].actionList)
        _actionList.splice(currentActionRef.actionIndex, 1)
        _processDetail[currentActionRef.containerType].actionList = _actionList
      }
    }
  }
  if (typesData.clientOperatorActionTypes.includes(currentActionRef.actionType)) {
    const containerIndex = _processDetail.onProcess.findIndex(onProcess => onProcess.containerId === currentActionRef.containerId)
    if (currentActionRef.mode === 'add') _processDetail.onProcess[containerIndex].actionList.push(currentActionDetail)
    if (currentActionRef.mode === 'update') _processDetail.onProcess[containerIndex].actionList[currentActionRef.actionIndex] = currentActionDetail
    if (currentActionRef.mode === 'delete') {
      const _actionList = _cloneDeep(_processDetail.onProcess[containerIndex].actionList)
      _actionList.splice(currentActionRef.actionIndex, 1)
      _processDetail.onProcess[containerIndex].actionList = _actionList
    }
  }

  try {
    const result = await smartChat.process({ headerId: header._id, process: _processDetail })
    if (result.status === 200) {
      dispatch({
        type: types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL,
        payload: _processDetail
      })
      onFinish && typeof onFinish === 'function' && onFinish()
      dispatch(reloadSmartchat({ onDepth: true }))
    }
  } catch (error) {
    if (Object.keys(modalActionRef).length) {
      dispatch(updateModalError({
        origin: '[Redux] saveActionDetail',
        message: `chatbot_error_action_${currentActionRef.mode}`
      }))
    } else {
      dispatch(updateAlternativesError({
        origin: '[Redux] saveActionDetail',
        message: `chatbot_error_action_${currentActionRef.mode}`
      }))
    }
  }

  if (Object.keys(modalActionRef).length) {
    dispatch(updateModalLoading(false))
  } else {
    dispatch(updateAlternativesLoading(false))
  }
}

const addContainer = (payload = {}) => async (dispatch, getStore) => {
  const { containerName, onFinish } = payload
  const {
    smartchatHeader: { header },
    smartchatDetails: { processDetail, modalError }
  } = getStore()

  if (modalError) dispatch(updateModalError(null))
  dispatch(updateModalLoading(true))

  if (!containerName) {
    dispatch(updateModalError({
      origin: '[Redux] addContainer',
      message: 'chatbot_error_container_name'
    }))
    dispatch(updateModalLoading(false))
    return
  }

  const _processDetail = _cloneDeep(processDetail)
  _processDetail.onProcess.push({
    containerId: uniqid('onProcess-'),
    containerName,
    containerOrder: _processDetail.onProcess.length + 1,
    containerType: 'onProcess',
    actionList: []
  })

  try {
    const result = await smartChat.process({ process: _processDetail, headerId: header._id })
    if (result.status === 200) {
      dispatch({
        type: types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL,
        payload: _processDetail
      })

      onFinish && typeof onFinish === 'function' && onFinish()
      dispatch(reloadSmartchat({ onDepth: true }))
    }
  } catch (error) {
    dispatch(updateModalError({
      origin: '[Redux] addContainer',
      message: 'chatbot_error_container_add'
    }))
  }

  dispatch(updateModalLoading(false))
}

const deleteContainer = (payload = {}) => async (dispatch, getStore) => {
  const { containerId, onFinish } = payload
  const {
    smartchatHeader: { header },
    smartchatDetails: { processDetail, modalError }
  } = getStore()

  if (modalError) dispatch(updateModalError(null))
  dispatch(updateModalLoading(true))

  const _processDetail = _cloneDeep(processDetail)
  const containerIndex = _processDetail.onProcess.findIndex(onProcess => onProcess.containerId === containerId)
  _processDetail.onProcess.splice(containerIndex, 1)

  try {
    const result = await smartChat.process({ process: _processDetail, headerId: header._id })
    if (result.status === 200) {
      dispatch({
        type: types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL,
        payload: _processDetail
      })

      onFinish && typeof onFinish === 'function' && onFinish()
      dispatch(reloadSmartchat({ onDepth: true }))
    }
  } catch (error) {
    dispatch(updateModalError({
      origin: '[Redux] addContainer',
      message: 'chatbot_error_container_delete'
    }))
  }

  dispatch(updateModalLoading(false))
}

const copyContainer = (payload = {}) => async (dispatch, getStore) => {
  const { containerData, copyToProcess, onCallback, onFinish } = payload
  const { modalError } = getStore().smartchatDetails

  if (modalError) dispatch(updateModalError(null))
  dispatch(updateModalLoading(true))

  if (!copyToProcess) {
    dispatch(updateModalError({
      origin: '[Redux] copyContainer',
      message: 'smartchat_error_container_copy_empty'
    }))
    dispatch(updateModalLoading(false))
    return
  }

  const processData = {
    eventType: containerData.containerType,
    event: containerData,
    copyToProcess
  }

  try {
    const result = await smartChat.copyProcess(processData)
    if (result.status === 200) {
      if (result.data.replace) {
        onCallback && typeof onCallback === 'function' && onCallback()
      } else {
        onFinish && typeof onFinish === 'function' && onFinish()
        dispatch(reloadSmartchat({ onDepth: true }))
      }
    }
  } catch (error) {
    dispatch(updateModalError({
      origin: '[Redux] copyContainer',
      message: 'chatbot_error_container_copy'
    }))
  }

  dispatch(updateModalLoading(false))
}

const confirmCopyContainer = (payload = {}) => async (dispatch, getStore) => {
  const { containerData, copyToProcess, onCallback, onFinish } = payload
  const { modalError } = getStore().smartchatDetails

  if (modalError) dispatch(updateModalError(null))
  dispatch(updateModalLoading(true))

  const processData = {
    eventType: containerData.containerType,
    event: containerData,
    copyToProcess,
    replace: true
  }

  try {
    const result = await smartChat.copyProcess(processData)
    if (result.status === 200) {
      onCallback && typeof onCallback === 'function' && onCallback()
      onFinish && typeof onFinish === 'function' && onFinish()
      dispatch(reloadSmartchat({ onDepth: true }))
    }
  } catch (error) {
    dispatch(updateModalError({
      origin: '[Redux] confirmCopyContainer',
      message: 'chatbot_error_container_copy'
    }))
  }

  dispatch(updateModalLoading(false))
}

const updateActionsErrors = (payload) => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_ACTIONS_ERRORS,
  payload
})

const updateModalLoading = (payload) => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_MODAL_LOADING,
  payload
})

const updateModalError = (payload) => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_MODAL_ERROR,
  payload
})

const updateLoading = (payload) => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_LOADING,
  payload
})

const updateError = (payload) => ({
  type: types.SMARTCHAT_DETAILS_UPDATE_ERROR,
  payload
})

const addLabelToProcess = (payload) => async (dispatch, getStore) => {
  const {
    smartchatDetails: { processDetail }
  } = getStore()

  const _processDetail = {
    ...processDetail,
    labels: payload.labels,
  }

  dispatch({
    type: types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL,
    payload: _processDetail
  })

}

export {
  getProcessDetail,
  deleteProcessDetail,
  updateModalActionRef,
  setInitialActionDetail,
  setActionDetail,
  deleteActionDetail,
  setActionValue,
  saveActionDetail,
  addContainer,
  deleteContainer,
  copyContainer,
  confirmCopyContainer,
  updateActionsErrors,
  updateModalLoading,
  updateModalError,
  addLabelToProcess,
}
